
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { addBlinkAnimation } from '@/utils/general';
import ParentOrderCard from '@/components/order-management/ParentOrderCard.vue';

@Component<OrderManagementList>({
	components: {
		ParentOrderCard
	}
})
export default class OrderManagementList extends Vue {
	@Prop({ type: Object, default: () => {} }) private orders!: CurrentOrders;
	@Prop({ type: Object, default: () => ({ pending: 0, inProgress: 0, completed: 0 }) }) private statusTotals!: { pending: number; inProgress: number; completed: number };
	@Prop({ type: Boolean, default: false }) private loadingStatus!: boolean;
	@Watch('statusTotals.pending')
	private onPendingChange(newValue: number, oldValue: number): void {
		if (newValue !== oldValue) {
			addBlinkAnimation(document.getElementById('pending-orders-amount-label'), 'new-orders', 3);
		}
	}

	@Watch('statusTotals.inProgress')
	private onInProgressChange(newValue: number, oldValue: number): void {
		if (newValue !== oldValue) {
			addBlinkAnimation(document.getElementById('in-progress-orders-amount-label'), 'new-orders', 3);
		}
	}

	@Watch('statusTotals.completed')
	private onCompletedChange(newValue: number, oldValue: number): void {
		if (newValue !== oldValue) {
			addBlinkAnimation(document.getElementById('completed-orders-amount-label'), 'new-orders', 3);
		}
	}

	private showScrollToTopButton: boolean = false;

	/**
	 * Check if there are more pending orders to load
	 *
 	 * @return {boolean}
	 */
	private get hasMorePendingOrders(): boolean {
		return this.orders.pending.length > 0 && this.orders.pending.length < this.statusTotals.pending;
	}

	/**
	 * Check if there are more in-progress orders to load
	 *
 	 * @return {boolean}
	 */
	private get hasMoreInProgressOrders(): boolean {
		return this.orders.inProgress.length > 0 && this.orders.inProgress.length < this.statusTotals.inProgress;
	}

	/**
	 * Check if there are more completed orders to load
	 *
 	 * @return {boolean}
	 */
	private get hasMoreCompletedOrders(): boolean {
		return this.orders.completed.length > 0 && this.orders.completed.length < this.statusTotals.completed;
	}

	/**
	 * On scroll event, check if the user has scrolled more than 140px, if so, show the scroll to top button
	 *
	 * @param {any} e
	 * @return {void}
	 */
	private onScroll(e: any): void {
		const max: number = 140;
		const top: number = window.pageYOffset || e.target.scrollTop || 0;
		this.showScrollToTopButton = top > max;
	}

	private scrollToTop(): void {
		this.$vuetify.goTo(0);
	}

}
